export default function socialIconsWidget(editor) {
  editor.DomComponents.addType('eb-social-icons', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-social-icons'
    },
    model: {
      defaults: {
        name: 'Social Icons',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-social-icons' },
        style: {
          'display': 'flex',
          'gap': '12px',
          'justify-content': 'center',
          'padding': '15px',
        },
        components: `
          <a href="#" style="display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background:#3b5998;color:#fff;font-size:18px;text-decoration:none;transition:opacity 0.2s;" title="Facebook"><i class="fa fa-facebook"></i></a>
          <a href="#" style="display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background:#1da1f2;color:#fff;font-size:18px;text-decoration:none;transition:opacity 0.2s;" title="Twitter"><i class="fa fa-twitter"></i></a>
          <a href="#" style="display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background:#e4405f;color:#fff;font-size:18px;text-decoration:none;transition:opacity 0.2s;" title="Instagram"><i class="fa fa-instagram"></i></a>
          <a href="#" style="display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background:#0077b5;color:#fff;font-size:18px;text-decoration:none;transition:opacity 0.2s;" title="LinkedIn"><i class="fa fa-linkedin"></i></a>
        `,
        traits: [
          { type: 'text', name: 'data-facebook', label: 'Facebook URL' },
          { type: 'text', name: 'data-twitter', label: 'Twitter URL' },
          { type: 'text', name: 'data-instagram', label: 'Instagram URL' },
          { type: 'text', name: 'data-linkedin', label: 'LinkedIn URL' },
          { type: 'select', name: 'data-shape', label: 'Shape', options: [
            { id: 'circle', label: 'Circle' },
            { id: 'square', label: 'Square' },
            { id: 'rounded', label: 'Rounded' },
          ]},
        ],
      },
    },
  })

  editor.BlockManager.add('eb-social-icons', {
    label: 'Social Icons',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19C20.92,17.39 19.61,16.08 18,16.08Z"/></svg>',
    content: { type: 'eb-social-icons' },
  })
}
